import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, shareReplay, catchError, throwError } from "rxjs";
import {
  ApiResponse,
  FetchResponse,
} from "../../../../app/shared/models/api-response.interface";
import { environment } from "../../../../environments/environment";
import { Category, SubCategory } from "../models/category-interface";

@Injectable({
  providedIn: "root",
})
export class CategoryApiService {
  apiUrl!: string;
  apiV!: string;
  private categories$?: Observable<ApiResponse<FetchResponse<Category[]>>> | null;

  constructor(private httpClient: HttpClient) {
    this.apiUrl = environment.apiURL;
    this.apiV = environment.version;
  }

  fetchCategories(): Observable<ApiResponse<FetchResponse<Category[]>>> {
    if (!this.categories$) {
      let params = new HttpParams();
      params = params.append("PageIndex", 0);
      params = params.append("PageSize", 10);
      this.categories$ = this.httpClient.get<ApiResponse<FetchResponse<Category[]>>>(
        this.apiUrl + `/api/${this.apiV}/Category`,
        { params: params }
      ).pipe(
        shareReplay({ bufferSize: 1, refCount: false }),
        catchError((err) => {
          this.categories$ = null;
          return throwError(() => err);
        })
      );
    }
    return this.categories$;
  }

  clearCache(): void {
    this.categories$ = null;
    this.categoriesWithSub$.clear();
  }

  private categoriesWithSub$ = new Map<boolean, Observable<ApiResponse<Category[]>>>();

  fetchCategoriesWithSub(isPersonalize: boolean = false): Observable<ApiResponse<Category[]>> {
    const cached = this.categoriesWithSub$.get(isPersonalize);
    if (cached) {
      return cached;
    }

    let params = new HttpParams();
    params = params.append("includeProductCount", true);
    params = params.append("IsPersonalize", isPersonalize);

    const request$ = this.httpClient.get<ApiResponse<Category[]>>(
      `${this.apiUrl}/api/${this.apiV}/Category/with-subcategories`,
      { params: params }
    ).pipe(
      shareReplay({ bufferSize: 1, refCount: false }),
      catchError((err) => {
        this.categoriesWithSub$.delete(isPersonalize);
        return throwError(() => err);
      })
    );

    this.categoriesWithSub$.set(isPersonalize, request$);
    return request$;
  }

  
}
